module.exports = __webpack_public_path__ + "fonts/NespressoLucas-Bold.svg?v=7e4ab4d70ea76a79db08c98535b33fc7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-Bold.svg
// module id = 628
// module chunks = 0